import React, { useContext, useEffect, useState } from 'react';
import YesNo from '../../../../../components/Dialog/YesNo';
import { store,actions } from './reducer';
import {store as mainStore } from '../../../../../store'
import { makeStyles } from '@material-ui/core/styles';
import TextField from '@material-ui/core/TextField';
import SelectStates from '../../../../../components/FormInputs/SelectStates';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import FleetsTextFields from 'components/TextFields/FleetsTextFields';
import Button from '@material-ui/core/Button';
import GpsFixedIcon from '@material-ui/icons/GpsFixed';
import PinOnMap from '../../../../../components/Dialog/PinOnMap';
import {useValidator,TYPES} from '../../../../../hooks/useValidator';
import FormHelperText from '@material-ui/core/FormHelperText'

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'grid',
    gridTemplateColumns: '1fr',
    gridGap: theme.spacing(1),
  },
  radio: {
    display: 'flex',
    flexFlow: 'row nowrap',
    '& > *:not(:last-child)': {
      marginRight: 10,
    },
  },
}));

const Form = () => {
  const classes = useStyles();
  const {
    state: { selected, cities, dialog },
    dispatch,
    refresh
  } = useContext(store);
  const {showError,showMessage} = useContext(mainStore);
  const city = cities?.docs.find((c) => c._id === selected);
  const initialValues = {
    mostUse:false,
    isDestinationOnly:true,
    priceCalculationType:'formula'
  };
  const [values, setValues] = useState(initialValues);
  const {
    title,
    state,
    mostUse,
    isDestinationOnly,
    priceCalculationType,
    fleet,
    location,
  } = values;
  const [inProgress, setInProgress] = useState(false);
  const [map, setMap] = useState(false);
  const validators = {
    title: [{ type: TYPES.REQUIRED }],
    state: [{ type: TYPES.REQUIRED }],
    location: [{ type: TYPES.REQUIRED }],
  };
  const [errors, validate] = useValidator(validators);

  const handleClose = async(agree) => {
    try {
      if(agree){
        if(validate({title,state,location})){
          const {data} = await actions.addCity(values);
          if(data?.ok) showMessage(data?.messages)
          dispatch({ type: 'CLOSE_DIALOG' });
          setValues(initialValues);
          refresh();
        }else throw('فیلدهای مشخص شده را اصلاح فرمائید')
      }
      else
      {
        dispatch({ type: 'CLOSE_DIALOG' });
        setValues(initialValues);
      }
    } catch (error) {
      showError(error);
    }
  };
  const handleChangeTitle = (e) => {
    const { value } = e.target;
    setValues({ ...values, title: value });
  };
  const handleSelectState = (selection) => {
    setValues({
      ...values,
      state: { title: selection.label, _id: selection.value },
    });
  };
  const handleChangeRadio = (e) => {
    let { name, value } = e.target;
    if(value==='yes') value = true;
    if(value==='no') value = false;
    setValues({ ...values, [name]: value});
  };
  const handleChangeFleets = (selection) => {
    setValues({ ...values, fleet: selection });
  };
  const handleSetPosition = (position) => {
    setValues({ ...values, location:{type:'Point',coordinates:position}})
  };
  const handleSetMarker = (marker) => {
    setValues({ ...values, location:{type:'Point',coordinates:marker}})
  };
  const handleCloseSelectLocation = () => {
    setMap(false);
  };

  useEffect(() => {
    if(city) setValues({ ...initialValues,...city });
  }, [city]);

  return (
    <YesNo
      title={city?._id ? `ویرایش شهر ${city.title}` : `افزودن شهر`}
      yes="ذخیره"
      no="صرفنظر"
      inProgress={inProgress}
      open={selected || dialog ? true : false}
      onClose={handleClose}
    >
      <div className={classes.root}>
        <TextField
          name="title"
          value={title || ''}
          onChange={handleChangeTitle}
          fullWidth
          variant="outlined"
          label="نام شهر"
          size="small"
          error={errors?.title || false}
          helperText={errors?.title?'نام شهر را بایستی وارد نمائید':''}
          onBlur={validate}
        />
        <SelectStates
          state={state?.title ? { label: state.title, value: state._id } : null}
          onSelect={handleSelectState}
          error={errors?.state || false}
          helperText={errors?.state?'استان بایستی انتخاب شود':''}
        />
        <FormControl component="fieldset">
          <FormLabel component="legend">شهر پرتردد</FormLabel>
          <RadioGroup
            name="mostUse"
            value={mostUse ? 'yes' : 'no'}
            className={classes.radio}
            onChange={handleChangeRadio}
          >
            <FormControlLabel
              value='yes'
              control={<Radio color="primary" />}
              label="بله"
              labelPlacement="end"
            />
            <FormControlLabel
              value='no'
              control={<Radio color="primary" />}
              label="خیر"
              labelPlacement="end"
            />
          </RadioGroup>
        </FormControl>
        <FormControl component="fieldset">
          <FormLabel component="legend">مبدا بارگیری</FormLabel>
          <RadioGroup
            name="isDestinationOnly"
            value={isDestinationOnly ? 'yes' : 'no'}
            className={classes.radio}
            onChange={handleChangeRadio}
          >
            <FormControlLabel
              value='no'
              control={<Radio color="primary" />}
              label="بله"
              labelPlacement="end"
            />
            <FormControlLabel
              value='yes'
              control={<Radio color="primary" />}
              label="خیر"
              labelPlacement="end"
            />
          </RadioGroup>
        </FormControl>
        <FormControl component="fieldset">
          <FormLabel component="legend">شیوه محاسبه کرایه</FormLabel>
          <RadioGroup
            name="priceCalculationType"
            value={priceCalculationType || 'formula'}
            className={classes.radio}
            onChange={handleChangeRadio}
          >
            <FormControlLabel
              value="formula"
              control={<Radio color="primary" />}
              label="سیستمی"
              labelPlacement="end"
            />
            <FormControlLabel
              value="default"
              control={<Radio color="primary" />}
              label="فایل اکسل"
              labelPlacement="end"
            />
            <FormControlLabel
              value="bycustomer"
              control={<Radio color="primary" />}
              label="صاحب‌بار"
              labelPlacement="end"
            />
          </RadioGroup>
        </FormControl>
        <FleetsTextFields
          selection={fleet || []}
          onChange={handleChangeFleets}
          title="ناوگان‌های آزاد در شهر (راننده کرایه را تعیین میکند)"
        />
        <Button
          endIcon={<GpsFixedIcon />}
          variant="contained"
          fullWidth
          color="secondary"
          onClick={() => setMap(true)}
        >
          {Array.isArray(location?.coordinates)?'تغییر موقعیت مکانی':'انتخاب موقعیت مکانی'}
        </Button>
        {errors?.location && <FormHelperText error={errors?.location || false}>تعیین موقعیت مکانی شهر الزامی است</FormHelperText>}
        {map && <PinOnMap
          open={true}
          position={location?.coordinates}
          marker={location?.coordinates}
          setMarker={handleSetMarker}
          setPosition={handleSetPosition}
          onClose={handleCloseSelectLocation}
        />}
      </div>
    </YesNo>
  );
};

export default React.memo(Form);
